import { useMemo } from "react";
import {
  usePublicThemes,
  useOrgThemes,
  type ThemeResponse,
} from "pages/media/components/themeEditor/hooks/useThemeApi";

export type ThemesLoadingState = {
  isLoading: boolean;
  publicThemes: ThemeResponse[];
  orgThemes: ThemeResponse[];
};

export const useGroupedThemes = (
  organizationId: string | undefined
): ThemesLoadingState => {
  const { data: publicThemesData, isLoading: publicThemesLoading } =
    usePublicThemes();
  const { data: orgThemesData, isLoading: orgThemesLoading } =
    useOrgThemes(organizationId);

  return useMemo(
    () => ({
      isLoading: publicThemesLoading || orgThemesLoading,
      publicThemes: publicThemesData?.items ?? [],
      orgThemes: orgThemesData?.items ?? [],
    }),
    [publicThemesData, publicThemesLoading, orgThemesData, orgThemesLoading]
  );
};
